export const NAME = 'nameSkill';
export const JOB_TITLES = 'jobTitles';
